import { Component, OnInit, Input } from '@angular/core';

@Component({
	selector: 'app-export-button',
	templateUrl: './export-button.component.html',
	styleUrls: ['./export-button.component.scss'],
})
export class ExportButtonComponent implements OnInit {
	@Input() exportFunctions: Map<String, Function>;
	@Input() printPage;
	@Input() blockId?;
	@Input() btnExportId?;

	constructor() {}

	ngOnInit() {}

	clickExportDropdown(event: Event) {
		$(event.target)
			.closest('div')
			.next()
			.toggleClass('show');
	}

	clickExportEmail() {
		this.exportFunctions.get('email')();
	}

	clickExportPrint() {
		this.exportFunctions.get('print')();
	}

	clickExportPdf() {
		this.exportFunctions.get('pdf')();
	}

	clickExportPpt() {
		this.exportFunctions.get('ppt')();
		// .Ppt()
	}

	clickExportExcel() {
		this.exportFunctions.get('excel')();
	}

	mourseLeaveMenu() {
		$(event.target)
			.find('.exportMenu')
			.removeClass('show');
	}
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/common-component/export-button/export-button.component.ts